export const allLetters = /\p{L}/u;

export const atLeastOneLetter = allLetters;

export const validEmail = /^[^@]+@([^@.]+\.)+\w{2,4}$/;

export const URL_FIND_REGEX = /((?:https?:\/\/|www\.)[^\s/$.?#].[^\s]*)/gi;

export const companySpecials = /[.,\-+()@"!^:<>/*=&#%'’?]/;

export const textSpecials = /[.,\-+()@"!^:<>/*=&#%'’?—–]/;
